module.exports = __webpack_public_path__ + "img/cont_icon04.9a293407.svg";